export function getCodeTemplate() {
  return `
  
<h1>Hello to anyone who reads this.</h1>






<p>Have a nice day;)</p>
  






























<!-- And now please stop the procrastination and work -->
`;
}
